import { BaseItem, NullablePartial } from '../common';
import * as Language from './language';
import { PrevisitFormTemplateFieldConfigWithConditions } from './formTemplateFieldConfig';
import * as PrevisitFormTemplateFieldConfig from './formTemplateFieldConfig';

interface Check {
  fieldConfigName: string;
  matchingValues: string[];
}

interface Rule {
  outcome: string;
  conditions: Check[][];
}

interface OutcomeRules {
  defaultOutcome: string;
  rules: Rule[];
}

export interface BasePrevisitFormTemplate {
  name: string;
  displayName: string;
  noteTemplateId: string | null;
  notificationSchemeId: string | null;
  outcomeRules: OutcomeRules | null;
  exportAsForm: boolean;
  hideWhenCompleted: boolean;
  deleted: boolean;
  deletedTimestamp: Date | null;
  version: number;
  organizationId: string | null;
  labels: string[] | null;
  isReviewable: boolean | null;
  formEhrId: string | null;
  recommendationTemplateId: string | null;
}

export interface PrevisitFormTemplate
  extends BaseItem,
    BasePrevisitFormTemplate {}

export interface PrevisitFormTemplateWithLocalizations
  extends PrevisitFormTemplate {
  localizations?: Localization[];
}

export interface PrevisitFormTemplateWithParametersAndFieldConfigs
  extends PrevisitFormTemplate {
  formTemplateFieldConfigs: PrevisitFormTemplateFieldConfigWithConditions[];
  localizations: Localization[];
  formTemplateParameters?: Parameter[];
  noteTemplateParameters?: Parameter[];
}
export interface DisplayablePrevisitFormTemplate extends PrevisitFormTemplate {
  fieldConfigsCount: number;
  fieldConfigsLastUpdated: string | null;
}

export type CreateValues = NullablePartial<
  Omit<
    BasePrevisitFormTemplate,
    'deleted' | 'deletedTimestamp' | 'exportAsForm' | 'hideWhenCompleted'
  > &
    Partial<
      Pick<BasePrevisitFormTemplate, 'exportAsForm' | 'hideWhenCompleted'>
    >
>;

export interface CreateLocalizationValues {
  language: Language.Language;
  displayName: string;
}
export type UpdateValues = Partial<BasePrevisitFormTemplate>;

export enum ParameterKind {
  Input = 'input',
  Textarea = 'textarea',
}

export interface Parameter {
  name: string;
  kind: ParameterKind;
  value?: string;
}

export interface FormTemplateParameters {
  [key: string]: string | undefined;
}

export interface NoteTemplateParameters {
  previsitChiefComplaints?: string;
  lastVisitDate?: string;
  lastSurgeryDate?: string;
}

export type Parameters = FormTemplateParameters & NoteTemplateParameters;

export interface PrevisitFormTemplateLocalization extends BaseItem {
  previsitFormTemplateLanguageId: string;
  displayName: string;
}

export interface Localization extends PrevisitFormTemplateLocalization {
  language: Language.Language;
  previsitFormTemplateFieldConfigs: PrevisitFormTemplateFieldConfig.PrevisitFormTemplateFieldConfigLocalization[];
}

export interface HistoryFormTemplates
  extends PrevisitFormTemplateWithLocalizations {
  formTemplateFieldConfigs?: PrevisitFormTemplateFieldConfig.PrevisitFormTemplateFieldConfigWithConditions[];
}

export interface BasePrevisitFormTemplateHistory {
  previsitFormTemplateId: string;
  userId: string;
  formTemplates: HistoryFormTemplates;
}

export interface PrevisitFormTemplateHistory
  extends BaseItem,
    BasePrevisitFormTemplateHistory {}
